import React from 'react';
import { Navbar } from '../components/Navbar';
import { ContactPage } from '../components/ContactPage';
import { Footer } from '../components/Footer';
export const Contact = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2341" data-mp="1qpwettuhjm93">
      <Navbar data-id="element-2342" data-mp="1qol9hple66fv" />
      <ContactPage data-id="element-2343" data-mp="1qn0exzz2uni0" />
      <Footer data-id="element-2344" data-mp="1lqjj0jlmz4ud" />
    </div>;
};